export default "__VITE_ASSET__2e550e40__"